<style lang="less" scoped>
  @import "../../../vars.less";
  .secondary {
    color: @text-color-secondary;
  }
  .button-container {
    padding: @space-normal;
    & > *:not(:last-child) {
      margin-bottom: @space-normal;
    }
  }
  .pt {
    margin-top: @space-small;
    background-color: #fff;
    padding: @space-normal;
    color: @text-color;
  }
  .pt-header {
    font-size: 14px;
    line-height: normal;
    padding-bottom: @space-medium;
    display: flex;
    align-items: center;
    margin-bottom: @space-medium;
  }
  .pt-header-left {
    // font-weight: bold;
    font-size: 16px;
    flex: auto;
  }
  .pt-header-right {
    font-size: 12px;
    flex: none;
    display: flex;
    align-items: center;
    & > *:not(:first-child) {
      margin-left: @space-medium;
    }
  }
  .material-list {
    padding: 0 @space-small;
  }
</style>

<template>
  <page-container class="urgent-order-apply" :title="$t('申请订单加急')" :loading="loading">
    <van-form label-align="right">
      <van-field rows="1" autosize type="input"
        v-model="form.OrderNumber" :disabled="!!$route.query.orderNumber"
        name="order_number"
        :label="$t('销售订单号')" />
      <van-field rows="1" autosize type="textarea"
        v-model="form.ProjectName"
        name="ProjectName"
        :label="$t('项目名称')" />
      <van-field
        clickable readonly
        name="ReqestSiemensDeliveryDateLastest"
        :value="form.ReqestSiemensDeliveryDateLastest"
        :label="$t('要求备妥时间')"
        placeholder="点击选择时间"
        @click="RDDLShow = true"
      />
      <van-popup v-model="RDDLShow" position="bottom" :get-container="getContainer">
        <van-datetime-picker :title="$t('要求备妥时间')"
          type="date" :min-date="new Date()"
          @confirm="onRDDLConfirm"
          @cancel="RDDLShow = false"
        />
      </van-popup>
      <picker :label="$t('加急原因')" :placeholder="$t('请选择加急原因')"
        v-model="form.ReasonCategory" :loading="RCTSLoading"
        value-field="Code"
        text-field="Name"
        :columns="RCTS" />
      <van-field :rows="2" autosize type="textarea"
        v-model="form.DatailResaon" maxlength="140" show-word-limit
        name="DatailResaon" :placeholder="$t('请填写描述信息（小于140字）')"
        :label="$t('备注')" />
    </van-form>
    <div class="pt" v-if="PTO.length">
      <div class="pt-header van-hairline--bottom">
        <span class="pt-header-left">{{ $t('PTO') }}</span>
        <span class="pt-header-right secondary">
          <van-checkbox v-model="ptoReq" :disabled="!PTO.some(it => !isItemDisabled(it))" icon-size="16" shape="square">
            <span>{{ $t('要求备妥时间') }}1</span>
          </van-checkbox>
        </span>
      </div>
      <material-list
        :items="PTO"
        @change="v => (PTO = v)"
        class="material-list"
        editable
        :collapsable="true"/>
    </div>
    <div class="pt" v-if="PTS.length">
      <div class="pt-header van-hairline--bottom">
        <span class="pt-header-left">{{ $t('PTS') }}</span>
        <span class="pt-header-right secondary">
          <van-checkbox v-model="ptsReq" icon-size="16" :disabled="!PTS.some(it => !isItemDisabled(it))" shape="square">
            <span>{{ $t('要求备妥时间') }}1</span>
          </van-checkbox>
        </span>
      </div>
      <material-list
        :items="PTS"
        @change="v => (PTS = v)"
        class="material-list"
        editable
        :collapsable="true"/>
    </div>
    <div class="pt" v-if="OTHER.length">
      <div class="pt-header van-hairline--bottom">
        <span class="pt-header-left">{{ $t('Other') }}</span>
        <span class="pt-header-right secondary">
          <van-checkbox v-model="otherReq" icon-size="16" :disabled="!OTHER.some(it => !isItemDisabled(it))" shape="square">
            <span>{{ $t('要求备妥时间') }}1</span>
          </van-checkbox>
        </span>
      </div>
      <material-list
        :items="OTHER"
        @change="v => (OTHER = v)"
        class="material-list"
        editable
        :collapsable="true"/>
    </div>
    <div class="button-container">
      <van-button block type="info" native-type="submit" size="small" round
        :loading="applyLoading" :disabled="!someShitSelected"
        @click="onSubmit">{{$t('提交')}}</van-button>
    </div>
  </page-container>
</template>

<script>
import PageContainer from '../../../components/PageContainer'
import Picker from '../../../components/Picker.vue'
import MaterialList from './MaterialList'
import format from '../../../utils/format'
import {
  Form,
  Field,
  Button,
  Popup,
  DatetimePicker,
  Checkbox,
  Notify,
  Toast
} from 'vant'

export default {
  name: 'urgent-order-apply',
  components: {
    'van-form': Form,
    'van-field': Field,
    'van-button': Button,
    'van-popup': Popup,
    'van-datetime-picker': DatetimePicker,
    'van-checkbox': Checkbox,
    Picker,
    PageContainer,
    MaterialList
  },
  data () {
    return {
      loading: false,
      form: {
        OrderNumber: this.$route.query.orderNumber || '',
        ProjectName: '',
        ReqestSiemensDeliveryDateLastest: format(new Date()),
        ReasonCategory: 0,
        DatailResaon: '',
        PreOrderNumber: '' // API required key, do not delete
      },
      RDDLShow: false,
      RCTS: [],
      RCTSLoading: false,
      PTS: [],
      PTO: [],
      OTHER: [],
      ptoReq: false,
      ptsReq: false,
      otherReq: false,
      applyLoading: false
    }
  },
  computed: {
    someShitSelected () {
      return this.PTO.some(it => it.IsExpedite) ||
        this.PTS.some(it => it.IsExpedite) ||
        this.OTHER.some(it => it.IsExpedite)
    }
  },
  watch: {
    ptoReq (v) {
      this.PTO = this.PTO.map(it => {
        !this.isItemDisabled(it) && (it.IsExpedite = v)
        return it
      })
    },
    ptsReq (v) {
      this.PTS = this.PTS.map(it => {
        !this.isItemDisabled(it) && (it.IsExpedite = v)
        return it
      })
    },
    otherReq (v) {
      this.OTHER = this.OTHER.map(it => {
        !this.isItemDisabled(it) && (it.IsExpedite = v)
        return it
      })
    }
  },
  methods: {
    format,
    getReasonCategories () {
      this.$apis.basic.getReasonCategories(
        loading => (this.RCTSLoading = loading)
      ).then(res => {
        if (res && res.length) {
          this.RCTS = res
          this.form.ReasonCategory = res[0].Code
        }
      })
    },
    getOrderInfo () {
      this.$apis.care.getOrderInfo(
        this.form.OrderNumber,
        loading => (this.loading = loading),
        (err) => {
          // code 204 means this order has been applied for urgent
          if (err.ErrorCode === '204') {
            this.$back()
          }
          return true
        }
      ).then(res => {
        if (!res) return
        if (res.ProjectName) {
          this.form.ProjectName = res.ProjectName
        }
        if (res.ItemSet && res.ItemSet.length) {
          const temp = res.ItemSet.map(item => ({
            ...item,
            ReqestSiemensDeliveryDate1: this.form.ReqestSiemensDeliveryDateLastest,
            IsExpedite: false
          }))
          this.PTS = temp.filter(item => item.item_category === 'PTS')
          this.PTO = temp.filter(item => item.item_category === 'PTO')
          this.OTHER = temp.filter(item => item.item_category !== 'PTS' && item.item_category !== 'PTO')
        }
        delete res.ItemSet
        this.form = {
          ...this.form,
          ...res
        }
      })
    },
    getItemShit (item) {
      return {
        itemNumber: item.item_number,
        IsExpedite: item.IsExpedite,
        ReqestSiemensDeliveryDate1: item.ReqestSiemensDeliveryDate1,
        Remark1: item.Remark1 || ''
      }
    },
    onSubmit () {
      if (!this.form.ProjectName.trim()) {
        Toast(this.$t('请填写项目名称'))
        return
      }

      if (!this.form.ReqestSiemensDeliveryDateLastest) {
        Toast(this.$t('请填写要求货物备妥时间'))
        return
      }

      if (!this.form.DatailResaon.trim()) {
        Toast(this.$t('请填写描述信息'))
        return
      }

      const data = { ...this.form }

      data.ItemSet = this.PTO.filter(it => it.IsExpedite).map(this.getItemShit)
        .concat(this.PTS.filter(it => it.IsExpedite).map(this.getItemShit))
        .concat(this.OTHER.filter(it => it.IsExpedite).map(this.getItemShit))

      this.$apis.care.applyUrgetnOrder(
        data,
        loading => (this.applyLoading = loading)
      ).then(res => {
        if (res) {
          Notify({
            type: 'success',
            message: this.$t('订单加急申请成功')
          })
          this.$back()
        }
      })
    },
    onRDDLConfirm (value) {
      const res = this.format(value)
      this.form.ReqestSiemensDeliveryDateLastest = res
      this.PTS = this.PTS.map(item => ({
        ...item,
        ReqestSiemensDeliveryDate1: res
      }))
      this.PTO = this.PTO.map(item => ({
        ...item,
        ReqestSiemensDeliveryDate1: res
      }))
      this.OTHER = this.OTHER.map(item => ({
        ...item,
        ReqestSiemensDeliveryDate1: res
      }))
      this.RDDLShow = false
    },
    getContainer () {
      return window.document.body
    },
    isItemDisabled (item) {
      return item.isRejection || !item.IsApply
    }
  },
  mounted () {
    this.getReasonCategories()
    if (this.form.OrderNumber) {
      this.getOrderInfo()
    }
  }
}
</script>
